var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechPattern2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 575.5 88.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.4;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.63px;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ex_2",
    "data-name": "ex 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2.52 88.3 27.32 73.97 27.32 45.34 2.52 31.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.53 73.97 126.53 45.34 101.73 31.02 76.93 45.34 76.93 73.97 101.73 88.3 126.53 73.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "176.14 73.97 176.14 45.34 151.34 31.02 126.53 45.34 126.53 73.97 151.34 88.3 176.14 73.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "275.35 73.97 275.35 45.34 250.55 31.02 225.74 45.34 225.74 73.97 250.55 88.3 275.35 73.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "324.96 73.97 324.96 45.34 300.15 31.02 275.35 45.34 275.35 73.97 300.15 88.3 324.96 73.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "374.56 73.97 374.56 45.34 349.76 31.02 324.96 45.34 324.96 73.97 349.76 88.3 374.56 73.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "473.77 73.97 473.77 45.34 448.97 31.02 424.17 45.34 424.17 73.97 448.97 88.3 473.77 73.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "523.38 73.97 523.38 45.34 498.58 31.02 473.77 45.34 473.77 73.97 498.58 88.3 523.38 73.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "572.99 73.97 572.99 45.34 548.18 31.02 523.38 45.34 523.38 73.97 548.18 88.3 572.99 73.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.93 73.97 76.93 45.34 52.12 31.02 27.32 45.34 27.32 73.97 52.12 88.3 76.93 73.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.74 73.97 225.74 45.34 200.94 31.02 176.14 45.34 176.14 73.97 200.94 88.3 225.74 73.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "424.17 73.97 424.17 45.34 399.37 31.02 374.56 45.34 374.56 73.97 399.37 88.3 424.17 73.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "52.01 31.09 76.81 45.41 101.61 31.09 101.61 2.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "101.61 2.45 101.61 31.09 126.42 45.41 151.22 31.09 151.22 2.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "200.83 2.45 200.83 31.09 225.63 45.41 250.43 31.09 250.43 2.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "250.43 2.45 250.43 31.09 275.24 45.41 300.04 31.09 300.04 2.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "300.04 2.45 300.04 31.09 324.84 45.41 349.64 31.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "399.25 2.45 399.25 31.09 424.05 45.41 448.86 31.09 448.86 2.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "448.86 2.45 448.86 31.09 473.66 45.41 498.46 31.09 498.46 2.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "498.46 2.45 498.46 31.09 523.26 45.41 548.07 31.09 548.07 2.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2.4 31.09 27.2 45.41 52.01 31.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "151.22 2.45 151.22 31.09 176.02 45.41 200.83 31.09 200.83 2.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "349.64 31.09 374.45 45.41 399.25 31.09 399.25 2.45"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 548.23,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 498.63,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 449.03,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 399.43,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 349.83,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 300.23,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 250.53,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 200.93,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 151.33,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 101.72,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 52.13,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2.53,
    cy: 31.05,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 548.23,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 498.63,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 449.03,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 399.43,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 300.23,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 250.53,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 200.93,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 151.33,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 101.72,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 572.97,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 572.97,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 523.36,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 523.36,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 473.75,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 473.75,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 424.15,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 424.15,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 374.54,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 374.54,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 324.94,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 324.94,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 275.33,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 275.33,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 225.72,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 225.72,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 176.12,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 176.12,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 126.51,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 126.51,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 76.91,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 76.91,
    cy: 73.98,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.3,
    cy: 45.34,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.3,
    cy: 73.98,
    r: 2.53
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechPattern2);
export default __webpack_public_path__ + "static/media/tech-pattern-2.df39b0315066c61b44db2dc3faf272f5.svg";
export { ForwardRef as ReactComponent };